import { colors } from "vuetify/lib";

const state = {
  paymentTypes: [
    { text: "Cash", value: "cash" },
    { text: "Check", value: "check" },
  ],
  statuses: [
    { text: "Cancelled", value: "cancelled", color: colors.red.base },
    { text: "In Progress", value: "in progress", color: colors.blue.base },
    { text: "Complete", value: "complete", color: colors.green.base },
  ]
};

const actions = {};

const mutations = {};

const getters = {
  getWhiteLabelOrderPaymentTypes(state) {
    return state.paymentTypes;
  },
  getWhiteLabelStatuses(state) {
    return state.statuses;
  }
};

export default {
  state,
  actions,
  mutations,
  getters,
};
